<template>
  <b-card
      title="Information"
      tag="article"
      style="max-width: 20rem; margin-top: 35px"
      class="mb-2"
  >
    <b-card-text>
      <hr />
      <p>
        <b-icon
            icon="geo-alt"
        />
        {{address1}} {{city}}, {{state}} {{zip}}
      </p>
      <p v-if="phone">
        <b-icon
            icon="telephone"
        />
        {{phone}}
      </p>
      <p v-if="email">
        <b-icon
            icon="mail"
        />
        {{email}}
      </p>
      <p v-if="url">
        <b-icon
            icon="globe2"
        />
        <b-link>
          {{url}}
        </b-link>
      </p>
      <p>
        <b-icon
            v-if="social.facebook && social.facebook.url && social.facebook.isShown"
            icon="facebook"
            @click="handleGoToSocial(`fb`,`https://facebook.com/${social.facebook.url}`)"
        />
        <b-icon
            v-if="social.instagram && social.instagram.url && social.instagram.isShown"
            style="margin-left: 15px"
            icon="instagram"
        />
        <b-icon
            v-if="social.linkedin && social.linkedin.url && social.linkedin.isShown"
            style="margin-left: 15px"
            icon="linkedin"
        />
        <b-icon
            v-if="social.twitter && social.twitter.url && social.twitter.isShown"
            style="margin-left: 15px"
            icon="twitter"
        />
      </p>
    </b-card-text>
  </b-card>
</template>

<script>
export default {
  name: "Site_Provider_OrgInfo",
  components: {},
  props: {
    siteData: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  computed: {
    organizationName() {
      return this.siteData && this.siteData.info && this.siteData.info.name ?
          this.siteData.info.name : null;
    },
    orgDescription() {
      return this.siteData && this.siteData.info && this.siteData.info.descriptioo ?
          this.siteData.info.description : null;
    },
    address1() {
      return this.siteData && this.siteData.info && this.siteData.info.address1 ?
          this.siteData.info.address1 : null;
    },
    city() {
      return this.siteData && this.siteData.info && this.siteData.info.city ?
          this.siteData.info.city : null;
    },
    state() {
      return this.siteData && this.siteData.info && this.siteData.info.state ?
          this.siteData.info.state : null;
    },
    phone() {
      return this.siteData && this.siteData.info && this.siteData.info.phone ?
          this.siteData.info.phone : null;
    },
    email() {
      return this.siteData && this.siteData.email && this.siteData.info.email ?
          this.siteData.info.email : null;
    },
    zip() {
      return this.siteData && this.siteData.info && this.siteData.info.zip ?
          this.siteData.info.zip : null;
    },
    url() {
      return this.siteData && this.siteData.info && this.siteData.info.url ?
          this.siteData.info.url : null;
    },
    social() {
      return this.siteData && this.siteData.social ?
          this.siteData.social : null;
    }
  },
  methods: {
    handleGoToSocial(socialType, socialURL){
      window.open(socialURL, "_blank");
    }
  },
  data() {
    return {};
  },
};
</script>
